<script>
export default {
  name: 'FilArianne',
  props: {
    step: {
      type: Number,
      required: true
    }
  }
};
</script>

<template>
  <v-stepper
    v-model="step"
    :alt-labels="$vuetify.breakpoint.smAndDown"
  >
    <v-stepper-header>
      <v-stepper-step
        step="1"
        :complete="step>1"
      >
        Panier
      </v-stepper-step>
      <v-divider />
      <v-stepper-step
        step="2"
        :complete="step>2"
      >
        Réglement
      </v-stepper-step>
      <v-divider />
      <v-stepper-step
        step="3"
        :complete="step>2"
      >
        Confirmation de commande
      </v-stepper-step>
    </v-stepper-header>
  </v-stepper>
</template>

<style lang="scss" scoped>

@import "~vuetify/src/styles/settings/_variables";
::v-deep{
  @media #{map-get($display-breakpoints, 'sm-only')} {
    .v-stepper__label {
        display: block !important;
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .v-stepper__step--active .v-stepper__label {
        display: block !important;
    }
  }
}
</style>
